import moment from 'moment';
import { Card } from 'primereact/card';
import { TabPanel, TabView } from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { withTranslation } from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionLink from '../components/ActionLink';
import CriteriaCalendarRangeComponent from '../components/criteria/CriteriaCalendarRangeComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import { CustomMessages } from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import MenuItemIcon from '../components/MenuItemIcon';
import BlockUi from '../components/waitPanel/BlockUi';
import { baseReportCsv, baseReportPdf, baseXLSXReport, createPinCardPdf } from '../report/ReportUtils';
import CardService from '../services/CardService';
import CardManageDialog from './CardManageDialog';
import SettingService from '../services/SettingService';

import CardRenewDialog from './CardRenewDialog';
class CardListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new CardService());
        this.state = {
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [],
            roleTypeOptions: [],
            cardsToRenew: [],
            listWasLimited: false,
            renewListLengthParam: 30,
            unAuthorizedList: {
                content: [],
                totalElements: 0,
            },
            originalUnAuthorizedList: {
                content: [],
                totalElements: 0,
            },
            activeList: {
                content: [],
                totalElements: 0,
            },
            originalActiveList: {
                content: [],
                totalElements: 0,
            },
            blockedList: {
                content: [],
                totalElements: 0,
            },
            originalBlockedList: {
                content: [],
                totalElements: 0,
            },
            expiredList: {
                content: [],
                totalElements: 0,
            },
            originalExpiredList: {
                content: [],
                totalElements: 0,
            },
            allList: {
                content: [],
                totalElements: 0,
            },
            originalAllList: {
                content: [],
                totalElements: 0,
            },
            plasticList: {
                content: [],
                totalElements: 0,
            },
            originalPlasticList: {
                content: [],
                totalElements: 0,
            },
            multienergeticList: {
                content: [],
                totalElements: 0,
            },
            originalMultienergeticList: {
                content: [],
                totalElements: 0,
            },
            highwayEnabledList: {
                content: [],
                totalElements: 0,
            },
            originalHighwayEnabledList: {
                content: [],
                totalElements: 0,
            },
            limitedAccessList: {
                content: [],
                totalElements: 0,
            },
            originalLimitedAccessList: {
                content: [],
                totalElements: 0,
            },
            toRenewList: {
                content: [],
                totalElements: 0,
            },
            originalToRenewList: {
                content: [],
                totalElements: 0,
            },
            filters: {},
            cards: [],
        };
        this.user = this.authService.getProfile();
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleOpenCardsRenewDialog = this.handleOpenCardsRenewDialog.bind(this);
        this.handleCloseCardsRenewDialog = this.handleCloseCardsRenewDialog.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleTypeCardTabChange = this.handleTypeCardTabChange.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
        this.generatePinReport = this.generatePinReport.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.settingService = new SettingService();
    }

    getDataKey() {
        return 'cardNumber';
    }

    getListTitle() {
        return 'cards.listTitle';
    }

    updateListElements(list) {
        return list && list.length
            ? list.map((item) => {
                item.expirationDate = new Date(item.expirationDate);
                return item;
            })
            : [];
    }

    readCriteriaFromCookie() {
        const agreementLimitedAccess = this.user.limitedAccess === true ? true : false;//8
        const highwayEnabled = this.user.highwayEnabled === true ? true : false; //6
        let activeIndex = this.readCookie(`your-cards-list-activeIndex`);
        if (activeIndex === undefined || activeIndex === null || activeIndex === '') {
            activeIndex = 0;
        }
        if(!agreementLimitedAccess && activeIndex === "8"){
            activeIndex = 0;
        }
        if(!highwayEnabled && activeIndex === "6"){
            activeIndex = 0;
        }
        const prevCriteria = this.state.criteria;
        const criteria =
            this.readCookie(this.getCriteriaName()) !== undefined && this.readCookie(this.getCriteriaName()) != null
                ? this.updateSearchCriteriaPrototype(JSON.parse(this.readCookie(this.getCriteriaName())))
                : this.getCleanSearchCriteriaPrototype();
        this.removeCookie(this.getCriteriaName());
        criteria.limit = prevCriteria.limit ? prevCriteria.limit : 10;
        criteria.unauthorized = parseInt(activeIndex) === 3 ? true : undefined;
        if (this._isMounted) {
            this.setState(
                (prevState) => ({
                    activeIndex: parseInt(activeIndex),
                    criteria,
                }),
                () => this.refreshTable()
            );
        }
    }

    updateSearchCriteria(criteria) {
        return {
            phoneNumber: this.props.phoneNumber,
            expirationDateFrom: criteria.expirationDateFrom,
            expirationDateTo: criteria.expirationDateTo,
            text: criteria.text,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            phoneNumber: this.props.phoneNumber,
            expirationDateFrom: undefined,
            expirationDateTo: undefined,
            text: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'cardNumber',
            sortAsc: false,
        };
    }

    initializeFromBackend() {
        this.settingService
            .getVehicleTypes()
            .then((vehicleTypeOpt) => {
                if (this._isMounted) {
                    this.setState({
                        vehicleTypeOpt,
                    });
                }
            })
            .catch(() => { this.showErrorMessage("Nie udało się pobrać listy typów pojazdów") });
        
        this.settingService
            .getValue('CARD_RENEW_LIST_LENGTH').then((resp) =>
            this.setState({
                renewListLengthParam: resp.value,
            })
        ).catch((err) => {
            this.showErrorMessage("Nie udało się pobrać długości listy kart do wznowienia")
        })
    }

    getCriteriaName() {
        return 'card-list-sc';
    }

    getContainerListName() {
        return 'card-list-container';
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    globalFilterFields() {
        return ['phoneNumber', 'cardNumber', 'driver', 'registrationNumber'];
    }

    applyFilters() {
        if (!this.hasFilter()) {
            this.setState({
                allList: { ...this.state.originalAllList },
                activeList: { ...this.state.originalActiveList },
                blockedList: { ...this.state.originalBlockedList },
                unAuthorizedList: { ...this.state.originalUnAuthorizedList },
                expiredList: { ...this.state.originalExpiredList },
                multienergeticList: { ...this.state.originalMultienergeticList },
                plasticList: { ...this.state.originalPlasticList },
                highwayEnabledList: { ...this.state.originalHighwayEnabledList },
                limitedAccessList: { ...this.state.originalLimitedAccessList },
                toRenewList: { ...this.state.originalToRenewList }
            });
            return;
        }

        const filteredList = this.processData();
        const filterByCardNumber = (list) =>
            list.filter(item => filteredList.some(filteredItem => filteredItem.cardNumber === item.cardNumber));

        this.setState({
            allList: {
                content: filteredList,
                totalElements: filteredList.length
            },
            activeList: {
                content: filterByCardNumber(this.state.originalActiveList.content),
                totalElements: filterByCardNumber(this.state.originalActiveList.content).length
            },
            blockedList: {
                content: filterByCardNumber(this.state.originalBlockedList.content),
                totalElements: filterByCardNumber(this.state.originalBlockedList.content).length
            },
            unAuthorizedList: {
                content: filterByCardNumber(this.state.originalUnAuthorizedList.content),
                totalElements: filterByCardNumber(this.state.originalUnAuthorizedList.content).length
            },
            expiredList: {
                content: filterByCardNumber(this.state.originalExpiredList.content),
                totalElements: filterByCardNumber(this.state.originalExpiredList.content).length
            },
            multienergeticList: {
                content: filterByCardNumber(this.state.originalMultienergeticList.content),
                totalElements: filterByCardNumber(this.state.originalMultienergeticList.content).length
            },
            plasticList: {
                content: filterByCardNumber(this.state.originalPlasticList.content),
                totalElements: filterByCardNumber(this.state.originalPlasticList.content).length
            },
            highwayEnabledList: {
                content: filterByCardNumber(this.state.originalHighwayEnabledList.content),
                totalElements: filterByCardNumber(this.state.originalHighwayEnabledList.content).length
            },
            limitedAccessList: {
                content: filterByCardNumber(this.state.originalLimitedAccessList.content),
                totalElements: filterByCardNumber(this.state.originalLimitedAccessList.content).length
            },
            toRenewList: {
                content: filterByCardNumber(this.state.originalToRenewList.content),
                totalElements: filterByCardNumber(this.state.originalToRenewList.content).length
            }
        });
    }

    handleChangeSc(inputType, parameters, event, matchMode, refreshFromBackend, onAfterStateChange, timeoutHandler, delay) {
        super.handleChangeSc(inputType, parameters, event, matchMode, refreshFromBackend, () => {
            if (onAfterStateChange) {
                onAfterStateChange();
            }
            this.applyFilters();
        }, timeoutHandler, delay);
    }

    renderCriteria() {
        const { t } = this.props;
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='text-sc'
                    name='text'
                    colClass='col-xl-6 col-lg-6 col-md-12 col-sm-12'
                    value={this.state.criteria.text}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={''}
                    showLabel={false}
                    placeholder={t('cards.textFilter')}
                    iconSvg='ico_cards_magnifying_glass'
                    iconSize='cards-magnifying-glass'
                    global={true}
                //refreshFromBackend
                />
                <CriteriaCalendarRangeComponent
                    id='expirationDate-sc'
                    idFrom='expirationDateFrom-sc'
                    idTo='expirationDateTo-sc'
                    name='expirationDate'
                    nameFrom='expirationDateFrom'
                    nameTo='expirationDateTo'
                    label={t('cards.expirationDate')}
                    colClass='col-xl-6 col-lg-6 col-md-12 col-sm-12'
                    from={this.state.criteria.expirationDateFrom}
                    to={this.state.criteria.expirationDateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    //refreshFromBackend
                    showButtonBar
                    sharedLabel
                    renderDash
                    placeholderFrom={t('cards.from')}
                    placeholderTo={t('cards.to')}
                    inputsClassName='col-6'
                    maxDateInfinite={true}
                    yearRange={'2000:2100'}
                />
            </div>
        );
    }

    prepareColumns() {
        const { t } = this.props;
        return [
            {
                field: 'cardNumber',
                header: t('cards.cardNumber'),
                sortable: true,
            },
            {
                key: 'cardKind',
                header: t('cards.cardKind'),
                sortable: true,
                sortField: 'cardKind',
                body: (el) => t(`EcCardKind.${el.cardKind}`),
            },
            {
                field: 'expirationDate',
                header: t('cards.expirationDate'),
                sortable: true,
                body: this.dateTemplateRed.bind(this, 'expirationDate', 'DD-MM-YYYY'),
            },
            { field: 'driver', header: t('cards.fullName'), sortable: true },
            { field: 'phoneNumber', header: t('cards.phoneNumber'), sortable: true },
            { field: 'registrationNumber', header: t('cards.registrationNumber'), sortable: true },
            {
                field: 'vehicleType', header: t('cards.vehicleType'), body: this.vehicleTypeTemplate.bind(this), sortable: true, bodyStyle: {
                    textAlign: 'right',
                    width: '890px'
                },
            },
            { field: 'cardType', header: t('cards.cardTypeHeader'), body: this.cardTypeTemplate.bind(this) },
            {
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate.bind(this),
                className: 'table-column-action',
            },
        ];
    }

    vehicleTypeRowTemplate(rowData) {
        let datatableRowStyle = '';
        let definedPinkStyle = 'hybridCardColumnClass';
        if (rowData.hybridCard === true) {
            datatableRowStyle = definedPinkStyle;
        } else {
            datatableRowStyle = 'my-custom-row';
        }
    }

    datatableRowColorTemplate(rowData) {
        if (rowData.hybridCard !== null) {
            if (rowData.hybridCard === true) {
                return 'hybridCardColumnClass'
            } else return '';
        } else return '';

    }

    vehicleTypeTemplate(rowData) {
        let fitOption = this.state.vehicleTypeOpt.filter(vt => vt.code === rowData.vehicleType);
        if (fitOption.length > 0) {
            return fitOption[0].label;
        } else {
            return '';
        }

    }

    hybridCardTemplate(rowData) {
        if (!!rowData.hybridCard) {
            return (
                <div className='d-flex'>
                    <MenuItemIcon id={`${rowData.id}-plastic-icon`} alt='' className={`icon-svg `} iconSvg={'ico_plastic_card_type'} />
                </div>
            );
        }
    }
    cardTypeTemplate(rowData) {
        const { t } = this.props;
        if (!!rowData.hasPlasticCard && !rowData.multiEnergeticCard) {
            return (
                <div className='d-flex'>
                    <MenuItemIcon
                        id={`${rowData.id}-virtual-icon`}
                        alt=''
                        className={`icon-svg virtual-next-plastic-card-icon-card-list`}
                        iconSvg={'ico_virtual_card_type'}
                        title={t('CardType.VIRTUAL')}

                    />
                    <MenuItemIcon id={`${rowData.id}-plastic-icon`} alt='' className={`icon-svg `} iconSvg={'ico_plastic_card_type'} title={t('CardType.PLASTIC')} />
                </div>
            );
        } else if (!!rowData.hasPlasticCard && !!rowData.multiEnergeticCard) {
            return (
                <div className='d-flex'>
                    <MenuItemIcon
                        id={`${rowData.id}-virtual-icon`}
                        alt=''
                        className={`icon-svg virtual-next-plastic-card-icon-card-list`}
                        iconSvg={'ico_virtual_card_type'}
                        title={t('CardType.VIRTUAL')}
                    />
                    <MenuItemIcon id={`${rowData.id}-plastic-icon`} alt='' className={`icon-svg `} iconSvg={'ico_multienergetic_plastic_card_type'} title={t('CardType.PLASTIC')} />
                </div>
            );
        }
        else {
            return (
                <MenuItemIcon id={`${rowData.id}-virtual-icon`} alt='' className={`icon-svg`} iconSvg={'ico_virtual_card_type'} title={t('CardType.VIRTUAL')} />
            );
        }
    }

    actionTemplate(rowData) {
        const { detailUrl, t } = this.props;
        return (
            <ActionLink
                label={t('details.manageButton')}
                handleClick={() => (window.location.href = `${detailUrl}/${rowData.cardNumber}`)}
                variant='blue'
                className='edit-blue-link'
                key={'view-button'}
            />
        );
    }

    dateTemplateRed(field, format, rowData) {
        const { t } = this.props;
        let expirationDateIsNull = moment(new Date(null)).toString() === moment(rowData[field]).toString();
        let dateStr = '';
        let expired = false;
        if (rowData[field] && moment(rowData[field]).isValid() && expirationDateIsNull === false) {

            if (!(moment(rowData[field]).isSameOrAfter(moment(new Date()), 'day'))) {
                expired = true;
            }
            dateStr = moment(rowData[field]).format(format);
        }
        if (rowData[field] && moment(rowData[field]).isValid() && expirationDateIsNull === true) {
            dateStr = t('cards.emptyExpirationDate');
        }
        return <span className={`${expired ? 'expired-date' : ''}`}>{dateStr}</span>;
    }

    generateReport(format) {
        const { t, lazy } = this.props;
        const list = (this.hasFilter() && this.state.selectAll && lazy === false) ? this.processData() : this.state.selectedList;

        const columns = [
            { header: t('cards.cardNumber'), field: 'cardNumber' },
            {
                header: t('cards.expirationDate'),
                field: 'expirationDate',
                getColFunction: this.dateTemplate.bind(this, 'expirationDate', 'DD-MM-YYYY'),
            },
            { header: t('cards.fullName'), field: 'driver' },
            { header: t('cards.phoneNumber'), field: 'phoneNumber' },
            { header: t('cards.registrationNumber'), field: 'registrationNumber' },
        ];
        if (format === 'pdf') {
            const blob = baseReportPdf({ list, title: t('cards.listTitle'), columns, landscape: true }, this.props.t);
            return Promise.resolve(blob);
        } else if (format === 'csv') {
            const fields = [
                { value: 'cardNumber', label: t('cards.cardNumber') },
                { value: this.dateTemplate.bind(this, 'expirationDate', 'DD-MM-YYYY'), label: t('cards.expirationDate') },
                { value: 'driver', label: t('cards.fullName') },
                { value: 'phoneNumber', label: t('cards.phoneNumber') },
                { value: 'registrationNumber', label: t('cards.registrationNumber') },
            ];
            return Promise.resolve(baseReportCsv(list, fields));
        } else if (format === 'xlsx' || format === 'ods') {
            const request = {};
            request.columns = columns;
            request.list = list;
            request.sheetName = t(this.getListTitle()).replaceAll(/[*?\][\\/]/g, ' ,');
            return baseXLSXReport(request, format);
        }
    }
    generatePinReport(e) {
        if (e) {
            e.preventDefault();
        }
        const { t } = this.props;
        const list = this.state.selectedList;
        const columns = [
            { header: t('cards.contentListReport.columns.cardNumber'), field: 'cardNumber' },
            {
                header: t('cards.contentListReport.columns.cardKind'),
                field: 'cardKind',
                getColFunction: this.enumTemplate.bind(this, 'EcCardKind', 'cardKind'),
            },
            { header: t('cards.contentListReport.columns.fullName'), field: 'driver' },
            { header: t('cards.contentListReport.columns.registrationNumber'), field: 'registrationNumber' },
            { header: t('cards.contentListReport.columns.pinHeader'), field: 'pin' },
        ];

        this.blockUi(() => {
            createPinCardPdf(list, columns, t, () => this.unblockUi());
        });
    }

    prepareHeaderItems() {
        const { t } = this.props;
        return this.isUserInRole('ROLE_FLEET')
            ? [
                { type: 'LABEL', className: 'float-left' },
                {
                    type: 'BUTTON',
                    className: 'right-side',
                    variant: 'white',
                    disabled: !this.state.selectedList || this.state.selectedList.length < 1,
                    customRenderFunction: this.renderPrintButton,
                },
                // {
                //     label: "Przedłuż ważność",
                //     onClick: this.handleOpenCardsRenewDialog,
                //     type: 'BUTTON',
                //     className: 'right-side',
                //     variant: 'white',
                //     disabled: !this.state.selectedList || this.state.selectedList.length < 1,
                //     rendered: this.state.activeIndex === 7,
                // },
                {
                    label: t('cards.manageGroup'),
                    onClick: this.handleOpenDialog,
                    type: 'BUTTON',
                    className: 'right-side',
                    variant: 'white',
                    disabled: !this.state.selectedList || this.state.selectedList.length < 1 || !this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') || this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER',
                },
                {
                    label: t('cards.contentListReport.buttonTitle'),
                    onClick: this.generatePinReport,
                    type: 'BUTTON',
                    className: 'right-side',
                    variant: 'white',
                    disabled: !this.state.selectedList || this.state.selectedList.length < 1,
                    rendered: this.authService.getProfile().agreementType === 'PREPAID',
                },
            ]
            : [];
    }

    getSelectedList(index) {
        switch (index) {
            case 0: return this.state.allList;
            case 1: return this.state.activeList;
            case 2: return this.state.blockedList;
            case 3: return this.state.unAuthorizedList;
            case 4: return this.state.expiredList;
            case 5: return this.state.multienergeticList;
            case 6: return this.state.highwayEnabledList;
            case 7: return this.state.toRenewList;
            case 8: return this.state.limitedAccessList;

            default: return null;
        }
    }

    handleOpenDialog(e) {
        if (e) {
            e.preventDefault();
        }
        const selectedList = this.state.selectAll
            ? this.getSelectedList(this.state.activeIndex)?.content || []
            : this.state.selectedList || [];
        this.setState({
            dialogVisible: true,
            cards: selectedList.map(e => e.cardNumber),
            dialogViewMode: 'EDIT',
        });
    }

    handleCloseDialog(e, clearList, callBack) {
        if (clearList) {
            this.setState({ dialogVisible: false, cards: [], selectedList: [] }, () => {
                if (callBack) {
                    callBack();
                }
            });
        } else {
            this.setState({ dialogVisible: false }, () => {
                if (callBack) {
                    callBack();
                }
            });
        }
    }

    handleOpenCardsRenewDialog(e) {
        if (e) {
            e.preventDefault();
        }
        const { selectedList, renewListLengthParam } = this.state;
        let cardsToRenew = this.state.cardsToRenew;
        const cutList = selectedList.length > renewListLengthParam ?  selectedList.slice(0, renewListLengthParam) : selectedList;
        const listWasAlreadyLimited = selectedList.length > renewListLengthParam ? true : false;
      
        cutList.forEach(e => {
            let renewalAvailable =
                e.expirationDate !== null && e.expirationDate !== undefined && moment(e.expirationDate).add(-60, 'day').isBefore(moment());
            if (renewalAvailable) {
                cardsToRenew.push({ cardNumber: e.cardNumber, plasticAvailable: e.hasPlasticCard === true })
            }
        })

        this.setState({
            renewDialogVisible: true,
            cardsToRenew: cardsToRenew,
            dialogViewMode: 'EDIT',
            listWasLimited: listWasAlreadyLimited,
        });
    }

    handleCloseCardsRenewDialog(e, clearList, callBack) {
        if (clearList) {
            this.setState({ renewDialogVisible: false, cardsToRenew: [], selectedList: [] }, () => {
                if (callBack) {
                    callBack();
                }
            });
        } else {
            this.setState({ renewDialogVisible: false }, () => {
                if (callBack) {
                    callBack();
                }
            });
        }
    }


    render() {
        const { t } = this.props;
        return (
            <div className='card-list-container'>
                {this.state.dialogVisible ? (
                    <CardManageDialog
                        className='card-list-manage-dialog'
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        cards={this.state.cards}
                        onHide={(e) => this.handleCloseDialog(e, false)}
                        visible={this.state.dialogVisible}
                        viewMode={this.state.dialogViewMode}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, true, () => {
                                this.readMessage();
                                this.refreshTable();
                            })
                        }
                        _isMounted={this._isMounted}
                    />
                ) : null}

                {this.state.renewDialogVisible ? (
                    <CardRenewDialog
                        mainRef={this.props.mainRef}
                        className='card-list-manage-dialog'
                        // cardNumber={this.state.cards}
                        cards={this.state.cardsToRenew}
                        onHide={(e) => this.handleCloseCardsRenewDialog(e, true)}
                        visible={this.state.renewDialogVisible}
                        afterSave={(e) => this.handleCloseCardsRenewDialog(e, true, () => {
                            this.readMessage();
                            this.refreshTable()
                        })}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showMessage={this.showMessage}
                        embedded
                        _isMounted={this._isMounted}
                        listWasLimited={this.state.listWasLimited}
                        listLengthParam={this.state.renewListLengthParam}
                    />
                ) : null}

                <BreadcrumbsItem to='/card-list'>{t('cards.listName')}</BreadcrumbsItem>
                {this.renderAddToTrustedDevicesDialog()}
                {this.renderView()}
            </div>
        );
    }

    onAfterGetList(res) {
        if (this.props.onAfterGetList) {
            this.props.onAfterGetList(res);
        }
        this.props.unblockUi();
    }

    handleValidForm() {
        this.unblockUi();
    }

    renderView() {
        const {t} = this.props;
        const agreementLimitedAccessTab = this.user.limitedAccess === true ? true : false;
        const highwayPaymentsTab = this.authService.isUserInRole('ROLE_FLEET') &&  this.authService.getProfile().agreementType === 'CASHLESS' && this.authService.isUserHasAnyPermission('PERMISSION_FULL_ACCESS_ADDITIONAL_SERVICES');

        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <Card
                        className='list-card card-list-container'
                    // header={this.renderHeader()}
                    >
                        <DivContainer rendered={this.props.phoneNumber === undefined || this.props.phoneNumber === null} colClass='row'>
                            {this.renderFilter()}
                        </DivContainer>
                        <DivContainer colClass='row'>{this.renderHeader()}</DivContainer>
                        {!this.props.cardTypePanels ? (
                            <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} className='sub-tabview-cards' scrollable>
                                <TabPanel header={`${t('cards.panelTitle.all')} (${this.state.allList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.allList?.content,
                                        this.state.allList?.totalElements
                                    )}
                                </TabPanel>
                                <TabPanel header={`${t('cards.panelTitle.active')} (${this.state.activeList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.activeList?.content,
                                        this.state.activeList?.totalElements
                                    )}
                                </TabPanel>
                                <TabPanel header={`${t('cards.panelTitle.blocked')} (${this.state.blockedList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.blockedList?.content,
                                        this.state.blockedList?.totalElements
                                    )}
                                </TabPanel>
                                <TabPanel header={`${t('cards.panelTitle.unauthorized')} (${this.state.unAuthorizedList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.unAuthorizedList?.content,
                                        this.state.unAuthorizedList?.totalElements
                                    )}
                                </TabPanel>
                                <TabPanel header={`${t('cards.panelTitle.expired')} (${this.state.expiredList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.expiredList?.content,
                                        this.state.expiredList?.totalElements
                                    )}
                                </TabPanel>
                                <TabPanel header={`${t('cards.panelTitle.multienergetic')} (${this.state.multienergeticList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.multienergeticList?.content,
                                        this.state.multienergeticList?.totalElements
                                    )}
                                </TabPanel>
                                { highwayPaymentsTab ? 
                                <TabPanel header={`${t('cards.panelTitle.highwayEnabled')} (${this.state.highwayEnabledList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.highwayEnabledList?.content,
                                        this.state.highwayEnabledList?.totalElements
                                    )}
                                </TabPanel> : null}
                                <TabPanel header={`${t('cards.panelTitle.renew')} (${this.state.toRenewList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.toRenewList?.content,
                                        this.state.toRenewList?.totalElements
                                    )}
                                </TabPanel>
                                { agreementLimitedAccessTab ? <TabPanel header={`${t('cards.panelTitle.limitedAccess')} (${this.state.limitedAccessList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.limitedAccessList?.content,
                                        this.state.limitedAccessList?.totalElements
                                    )}
                                </TabPanel> : null}
                            </TabView>
                        ) : (
                            <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTypeCardTabChange}>
                                <TabPanel header={`${t('cards.panelTitle.all')} (${this.state.allList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.allList?.content,
                                        this.state.allList?.totalElements
                                    )}
                                </TabPanel>
                                <TabPanel header={`${t('cards.panelTitle.plastic')} (${this.state.plasticList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.plasticList?.content,
                                        this.state.plasticList?.totalElements
                                    )}
                                </TabPanel>
                                <TabPanel header={`${t('cards.panelTitle.virtual')} (${this.state.allList?.totalElements})`}>
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.allList?.content,
                                        this.state.allList?.totalElements
                                    )}
                                </TabPanel>
                            </TabView>
                        )}
                    </Card>
                </BlockUi>
            </DivContainer>
        );
    }

    getList() {
        const { criteria } = this.state;
        this.setState({ selectAll: false });
        this.service
            .getList(criteria)
            .then((res) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            unAuthorizedList: {
                                content: this.updateListElements(res.unAuthorizedList?.content),
                                totalElements: res.unAuthorizedList?.totalElements,
                            },
                            originalUnAuthorizedList: {
                                content: this.updateListElements(res.unAuthorizedList?.content),
                                totalElements: res.unAuthorizedList?.totalElements,
                            },
                            activeList: {
                                content: this.updateListElements(res.activeList?.content),
                                totalElements: res.activeList?.totalElements,
                            },
                            originalActiveList: {
                                content: this.updateListElements(res.activeList?.content),
                                totalElements: res.activeList?.totalElements,
                            },
                            blockedList: {
                                content: this.updateListElements(res.blockedList?.content),
                                totalElements: res.blockedList?.totalElements,
                            },
                            originalBlockedList: {
                                content: this.updateListElements(res.blockedList?.content),
                                totalElements: res.blockedList?.totalElements,
                            },
                            expiredList: {
                                content: this.updateListElements(res.expiredList?.content),
                                totalElements: res.expiredList?.totalElements,
                            },
                            originalExpiredList: {
                                content: this.updateListElements(res.expiredList?.content),
                                totalElements: res.expiredList?.totalElements,
                            },
                            plasticList: {
                                content: this.updateListElements(res.plasticList?.content),
                                totalElements: res.plasticList?.totalElements,
                            },
                            originalPlasticList: {
                                content: this.updateListElements(res.plasticList?.content),
                                totalElements: res.plasticList?.totalElements,
                            },
                            multienergeticList: {
                                content: this.updateListElements(res.multienergeticList?.content),
                                totalElements: res.multienergeticList?.totalElements,
                            },
                            originalMultienergeticList: {
                                content: this.updateListElements(res.multienergeticList?.content),
                                totalElements: res.multienergeticList?.totalElements,
                            },
                            allList: {
                                content: this.updateListElements(res.allList?.content),
                                totalElements: res.allList?.totalElements,
                            },
                            originalAllList: {
                                content: this.updateListElements(res.allList?.content),
                                totalElements: res.allList?.totalElements,
                            },
                            highwayEnabledList: {
                                content: this.updateListElements(res.highwayEnabledList?.content),
                                totalElements: res.highwayEnabledList?.totalElements,
                            },
                            originalHighwayEnabledList: {
                                content: this.updateListElements(res.highwayEnabledList?.content),
                                totalElements: res.highwayEnabledList?.totalElements,
                            },
                            limitedAccessList: {
                                content: this.updateListElements(res.limitedAccessList?.content),
                                totalElements: res.limitedAccessList?.totalElements,
                            },
                            originalLimitedAccessList: {
                                content: this.updateListElements(res.limitedAccessList?.content),
                                totalElements: res.limitedAccessList?.totalElements,
                            },
                            allList: {content: this.updateListElements(res.allList?.content), totalElements: res.allList?.totalElements},
                            toRenewList: {
                                content: this.updateListElements(res.toRenewList?.content),
                                totalElements: res.toRenewList?.totalElements,
                            },
                            originalToRenewList: {
                                content: this.updateListElements(res.toRenewList?.content),
                                totalElements: res.toRenewList?.totalElements,
                            },
                            allList: { content: this.updateListElements(res.allList?.content), totalElements: res.allList?.totalElements },
                            loading: false,
                            list: this.updateListElements(res.allList?.content),
                            size: res.allList?.totalElements,
                        },
                        () => {
                            this.onAfterGetList(res);
                            this.applyFilters()
                        }
                    );
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            unAuthorizedList: {content: [], totalElements: 0},
                            activeList: {content: [], totalElements: 0},
                            blockedList: {content: [], totalElements: 0},
                            expiredList: {content: [], totalElements: 0},
                            multienergeticList: {content: [], totalElements: 0},
                            highwayEnabledList: {content: [], totalElements: 0},
                            limitedAccessList: {content: [], totalElements: 0},
                            toRenewList: { content: [], totalElements: 0 },
                            allList: { content: [], totalElements: 0 },
                            loading: false,
                        },
                        () => {
                            this.afterGetListError();
                        }
                    );
                }
            });
    }

    handleTabChange(e) {
        this.setState(
            (prevState) => ({
                activeIndex: e.index,
                selectAll: false,
                selectedList: [],
            }),
            () => {
                this.saveCookie(`your-cards-list-activeIndex`, this.state.activeIndex);
            }
        );
    }

    handleOnSelectAllChange(e) {
        const selectAll = e.checked;
        if (selectAll) {
            if (this.props.lazy) {
                let allCriteria = { ...this.state.criteria };
                allCriteria.firstResult = 0;
                allCriteria.maxResults = 2147483647;
                this.setState({ loading: true });
                this.service
                    .getList(allCriteria)
                    .then((data) => {
                        if (this._isMounted) {
                            this.setState({
                                selectAll: true,
                                selectedList: this.getContentFromResponse(data),
                                loading: false,
                            });
                        }
                    })
                    .catch((err) => {
                        this.setState({ loading: false });
                    });
            } else {
                if (this.state.activeIndex >= 0) {
                    switch (this.state.activeIndex) {
                        case 0:
                            this.setState({
                                selectAll: true,
                                list: this.state.originalAllList.content,
                                selectedList: this.state.originalAllList.content
                            });
                            break;
                        case 1:
                            this.setState({
                                selectAll: true,
                                list: this.state.originalActiveList.content,
                                selectedList: this.state.originalActiveList.content
                            });
                            break;
                        case 2:
                            this.setState({
                                selectAll: true,
                                list: this.state.originalBlockedList.content,
                                selectedList: this.state.originalBlockedList.content
                            });
                            break;
                        case 3:
                            this.setState({
                                selectAll: true,
                                list: this.state.originalUnAuthorizedList.content,
                                selectedList: this.state.originalUnAuthorizedList.content
                            });
                            break;
                        case 4:
                            this.setState({
                                selectAll: true,
                                list: this.state.originalExpiredList.content,
                                selectedList: this.state.originalExpiredList.content
                            });
                            break;
                        case 5:
                            this.setState({
                                selectAll: true,
                                list: this.state.originalMultienergeticList.content,
                                selectedList: this.state.originalMultienergeticList.content
                            });
                            break;
                        case 6:
                            this.setState({
                                selectAll: true,
                                list: this.state.originalHighwayEnabledList.content,
                                selectedList: this.state.originalHighwayEnabledList.content
                                });
                                break;               
                        case 7:
                            this.setState({
                                selectAll: true,
                                list: this.state.originalToRenewList.content,
                                selectedList: this.state.originalToRenewList.content
                            });
                            break;
                        case 8:
                            this.setState({
                                selectAll: true,
                                list: this.state.originalLimitedAccessList.content,
                                selectedList: this.state.originalLimitedAccessList.content
                            });
                            break;      
                        default:
                            this.setState({
                                selectAll: true,
                                selectedList: this.state.list
                            });
                    }
                }
            }
        } else {
            this.setState({
                selectAll: false,
                selectedList: [],
                loading: false,
            });
        }
    }

    getContentFromResponse(response) {
        if (this.state.activeIndex >= 0) {
            switch (this.state.activeIndex) {
                case 0:
                    return response.allList.content;
                case 1:
                    return response.activeList.content;
                case 2:
                    return response.blockedList.content;
                case 3:
                    return response.unAuthorizedList.content;
                case 4:
                    return response.expiredList.content;
                case 5:
                    return response.multienergeticList.content;
                case 6:
                    return response.highwayEnabledList.content;
                case 7:
                    return response.toRenewList.content;
                case 8:
                    return response.limitedAccessList.content;
               
                default:
                    return [];
            }
        }
        return [];
    }

    getTotalElements() {
        if (this.state.activeIndex >= 0) {
            switch (this.state.activeIndex) {
                case 0:
                    return this.state.allList.totalElements;
                case 1:
                    return this.state.activeList.totalElements;
                case 2:
                    return this.state.blockedList.totalElements;
                case 3:
                    return this.state.unAuthorizedList.totalElements;
                case 4:
                    return this.state.expiredList.totalElements;
                case 5:
                    return this.state.multienergeticList.totalElements;
                case 6:
                    return this.state.highwayEnabledList.totalElements;
                case 7:
                    return this.state.toRenewList.totalElements;
                case 8:
                    return this.state.limitedAccessList.totalElements;
                default:
                    return [];
            }
        }
        return [];
    }

    handleTypeCardTabChange(e) {
        this.setState(
            (prevState) => ({
                activeIndex: e.index,
                loading: true,
                criteria: {
                    ...prevState.criteria,
                    status: e.index === 0 ? 'ALL' : e.index === 1 ? 'PLASTIC' : e.index === 2 ? 'VIRTUAL' : undefined,
                },
            }),
            () => {
                this.refreshTable();
                this.saveCookie(`your-cards-list-activeIndex`, this.state.activeIndex);
            }
        );
    }
}

CardListContainer.defaultProps = {
    lazy: false,
    customDatatableRowStyle: true,
    disableSelection: false,
    selectionMode: 'multiple',
    cardTypePanels: false,
    detailUrl: '#/card-details',
};

CardListContainer.propTypes = {
    phoneNumber: PropTypes.string,
    cardTypePanels: PropTypes.bool,
    handleGoToDetail: PropTypes.func,
};

export default withTranslation()(CardListContainer);
